var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"language-selection"},[_c('v-select',{attrs:{"value":_vm.languages,"options":_vm.unusedLanguages,"multiple":true,"autocomplete":"on","placeholder":"All Languages","components":{Deselect: _vm.Deselect}},on:{"input":_vm.changeLanguages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }